import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="w-full bg-cream py-16 md:py-24" data-id="element-94">
      <div className="max-w-6xl mx-auto px-6 md:px-12" data-id="element-95">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-96">
          {/* Left: Copy */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="space-y-6" data-id="element-97">
            <p className="text-sm font-medium tracking-wider text-gray-600 uppercase" data-id="element-98">
              PRE-LAUNCH · AUSTRALIA
            </p>

            <h1 className="font-headline text-5xl md:text-6xl lg:text-7xl leading-tight text-charcoal" data-id="element-99">
              The Feel-Good Energy <span className="text-pink" data-id="element-100">Ritual.</span>
            </h1>

            <p className="text-lg md:text-xl text-gray-700 leading-relaxed" data-id="element-101">
              A citrus energy + hydration powder for gym-focused young Aussies
              done with coffee crashes, anxious energy, and harsh pre-workout.
            </p>

            <p className="text-base text-gray-600" data-id="element-102">
              Made for training days, deep work, and the afternoon dip.
            </p>

            {/* Benefit chips */}
            <div className="flex flex-wrap gap-3 pt-2" data-id="element-103">
              {['40 servings', '125mg caffeine / scoop', 'Hydration-first', 'Citrus'].map(chip => <span key={chip} className="px-4 py-2 bg-white rounded-full text-sm font-medium text-charcoal shadow-sm" data-id="element-104">
                  {chip}
                </span>)}
            </div>

            {/* CTA */}
            <div className="pt-4" data-id="element-105">
              <a href="https://forms.gle/TCr9CceLKLVH7UWr6" target="_blank" rel="noopener noreferrer" className="inline-block px-8 py-4 bg-pink text-white font-semibold rounded-full hover:opacity-90 transition-opacity" data-id="element-106">
                JOIN WAITLIST →
              </a>
              <p className="text-sm text-gray-500 mt-3" data-id="element-107">
                First drop: 250 Citrus pouches. Early list gets notified first.
              </p>
            </div>
          </motion.div>

          {/* Right: Product image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="flex justify-center" data-id="element-108">
            <img src="https://cdn.magicpatterns.com/uploads/rio1h7PrLwaVnQDrGetzpG/ChatGPT_Image_Jun_7,_2026,_02_10_17_PM.png" loading="eager" alt="Zesty Citrus Pouch" className="w-full max-w-md mix-blend-multiply" data-id="element-109" />
          </motion.div>
        </div>
      </div>
    </section>;
}